module.exports = __webpack_public_path__ + "img/mess_icon1.422917a6.svg";